const APP_VERSION = process.env.REACT_APP_VERSION || Date.now();

export function buildJsonUrl(path) {
  if (!path || typeof path !== "string") return path;
  const separator = path.includes("?") ? "&" : "?";
  return `${path}${separator}v=${APP_VERSION}`;
}

export function fetchJson(path) {
  return fetch(buildJsonUrl(path));
}
